











































































































































































import {Component, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import L from "leaflet";
import {LIcon, LMap, LMarker, LTileLayer} from "vue2-leaflet";
import {EUserType} from "@/types";
import {imgmarker} from "@/utils";
import EventBus from "@/EventBus";

const axios = require('axios');

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon
    },
    computed: {
        ...mapGetters({user: 'user', profile: 'profile', isCompany: 'isCompany', isWorker: 'isWorker'})
    },
    name: "Home"
})
export default class Home extends Vue {
    private user?: any;
    private profile?: any;
    private center = L.latLng(43.8398731, 10.4766789)
    private zoom: number = 9;
    private url = "https://{s}.tile.osm.org/{z}/{x}/{y}.png"


    private announcements: any[] = [];

    get filteredAnnouncements() {
        return this.announcements.filter((a) => {
            return a.hasOwnProperty('lat') &&
                a.hasOwnProperty('lng')
        })
    }

    private getMarker(p: any) {
        if (p.options.tipologia == EUserType.Company) {
            return (imgmarker as any)['a' + p.options.settori];
        } else if (p.options.tipologia == EUserType.Worker) {
            return (imgmarker as any)['r' + p.options.settori];
        }
    }

    get mapMarkers() {
        return this.filteredAnnouncements.map((a) => {
            const settori = a.settori.sort().join('')
            return {
                marker: new L.latLng(a.lat, a.lng),
                id: a.id,
                options: {
                    tipologia: a.tipologia,
                    settori: settori ? settori : '_'
                }
            };
        })

    }

    private mounted() {
        axios.get('https://us-central1-jobtojob-c9b04.cloudfunctions.net/announcements/').then((res: any) => {
            this.announcements = res.data;
        })
        let self = this;
        let myNav = document.getElementById('myNav');
        (self.$el as HTMLElement).onscroll = function () {

            if (self.$el.scrollTop >= 100) {
                EventBus.$emit('nav:colored', true)
            } else {
                EventBus.$emit('nav:colored', false)
            }
        }
    }

}

